module.exports = __webpack_public_path__ + "static/media/2.f16568f9.JPG";